import React from 'react';
import { useLanguage, t } from './i18n';
import './LegalPage.css';
import { CookieSettingsButton } from './CookieBanner';
export default function LegalLinks({compact=false}) {
  useLanguage();
  return <nav className={`legal-links${compact?' legal-links-compact':''}`} aria-label={t('Información legal')}>
    <a href="/impressum">{t('Aviso legal')}</a><a href="/datenschutz">{t('Privacidad')}</a><a href="/cookies">{t('Almacenamiento y cookies')}</a>
    <CookieSettingsButton />
    <a href="mailto:info@jaragency.de?subject=Scene%20Share%20XR%20%E2%80%94%20Contenido%20%2F%20Inhalt%20%2F%20Content">{t('Reportar contenido')}</a>
  </nav>;
}
